module.exports = __webpack_public_path__ + "static/media/noncheckb.3bed7d39.svg";